import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../shared/ui/button';
import { useResize } from '../hooks/use_resize';
import { Flex } from './common/flex';
import { UserContext } from './contexts/user_context';
import { DoubleArrowLeft } from './icons/double_arrow_left';
import { Menu } from './menu';

export default function Sidebar({ isShow = true, onClose }: { isShow: boolean; onClose: () => void }) {
  const { isExtraLargeScreen } = useResize();
  const navigate = useNavigate();
  const userContext = useContext(UserContext);

  const handleClickMainLogo = () => {
    if (userContext.sign_in_url) {
      window.location.href = userContext.sign_in_url;
    } else {
      navigate('/');
    }
  };

  return (
    <div className={`sidebar ${isShow && !isExtraLargeScreen ? 'sidebar_opened' : ''}`}>
      <Flex align={'center'} className={'sidebar__logo_wrapper'}>
        <div className={'sidebar__logo'} onClick={handleClickMainLogo} />
        <Button
          variant={'outline'}
          className={'sidebar__btn'}
          onClick={onClose}
          title={'Скрыть меню'}
          icon={<DoubleArrowLeft />}
        />
      </Flex>
      <Menu />
    </div>
  );
}
